var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCancelOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22C21.5523 22 22 22.4477 22 23C22 23.5523 21.5523 24 21 24H7C6.44772 24 6 23.5523 6 23C6 22.4477 6.44772 22 7 22H21ZM14 2C14.5523 2 15 2.44772 15 3V16.585L17.2929 14.2929C17.6834 13.9024 18.3166 13.9024 18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071L14.7071 19.7071C14.3166 20.0976 13.6834 20.0976 13.2929 19.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929C6.68342 10.9024 7.31658 10.9024 7.70711 11.2929L13 16.585V3C13 2.44772 13.4477 2 14 2Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5355 4.53553C20.4882 2.5829 23.654 2.5829 25.6066 4.53553C27.5592 6.48815 27.5592 9.65397 25.6066 11.6066C23.654 13.5592 20.4882 13.5592 18.5355 11.6066C16.5829 9.65397 16.5829 6.48815 18.5355 4.53553ZM19.714 5.71404C19.4119 6.01623 19.3903 6.49277 19.6493 6.81987L19.714 6.89255L20.8926 8.07106L19.714 9.24957C19.3886 9.57501 19.3886 10.1026 19.714 10.4281C20.0162 10.7303 20.4928 10.7519 20.8199 10.4928L20.8926 10.4281L22.0711 9.24957L23.2496 10.4281C23.575 10.7535 24.1027 10.7535 24.4281 10.4281C24.7303 10.1259 24.7519 9.64935 24.4928 9.32226L24.4281 9.24957L23.2496 8.07106L24.4281 6.89255C24.7535 6.56711 24.7535 6.03947 24.4281 5.71404C24.1259 5.41185 23.6494 5.39026 23.3223 5.64928L23.2496 5.71404L22.0711 6.89255L20.8926 5.71404C20.5671 5.3886 20.0395 5.3886 19.714 5.71404Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCancelOutline);
export default __webpack_public_path__ + "static/media/download_cancel_outline.5cd07d9c1e188b8ae79b42be1ed89f5b.svg";
export { ForwardRef as ReactComponent };